import {css} from '@emotion/react';
import {Devices, gutters, paddings, tokens} from '@styles/tokens';
import {fontWeight, mq} from '@styles/helpers';
import {colors} from '@styles/colors';

const getSiteWidth = (padding: number) => `calc(var(--document-width) - ${padding}px * 2)`;

export const globals = css`

  /* Dynamic Variables */
  :root {    
    --fontSize-paragraph: 12px;
    --header-height: 78px;
    --footer-height: 80px;
    /* --document-width: 100vw; */
    --document-width: calc(100vw - (100vw - 100%));
    --site-width: ${getSiteWidth(paddings.desktop)};
    --site-height: calc(calc(100 * var(--vh)) - var(--header-height));
    --padding-bottom: 40px;
    --padding: calc((var(--document-width) - var(--site-width)) / 2);
    --gutter: ${gutters.desktop}px;
    --footer-height: 80px;

    ${mq(Devices.laptop)} {
      --site-width: ${getSiteWidth(paddings.laptop)};
      --gutter: ${gutters.laptop}px;
      --padding: ${paddings.laptop}px;
    }

    ${mq(Devices.laptop)} {
      --site-width: ${getSiteWidth(paddings.tablet)};
      --padding: ${paddings.tablet}px;
      --gutter: ${gutters.tablet}px;
    }

    ${mq(Devices.mobile)} {
      --site-width: ${getSiteWidth(paddings.mobile)};
      --padding: ${paddings.mobile}px;
      --gutter: ${gutters.mobile}px;
    }
  }

  /* Gets rid of the outline for mouse users but preserves it for keyboard users. */
  :focus:not(:focus-visible) {
    outline: none;
  }

  
  *,
  *::before,
  *::after {
    box-sizing: inherit;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .react-datepicker__day {        
    font-weight: 100;
  }

  .react-datepicker__day--highlighted-custom {        
    font-weight: 800;
  }

  .react-datepicker__day--selected{
    background-color: ${colors.mainTextColor};
    color: ${colors.white};
    border-radius: 50%;
  }

  .react-datepicker__day:hover:not(.react-datepicker__day--highlighted-custom) {
    background-color: transparent!important;
  }

  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    border-radius: 50%;
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background-color: transparent;
  }

  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__quarter-text--today,
  .react-datepicker__year-text--today {
    /* font-size: 12px; */
    /* line-height: 1; */
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: calc(100% + 1px);
      height: calc(100% + 1px);
      border-radius: 30px;
      border: 2px solid ${colors.mainTextColor};
    }

    &.react-datepicker__day--selected {
      &:after {
        display: none;
      }
    }
  }

  html,
  body,
  #__next {
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    background:#f5f5f5;
    min-height: -webkit-fill-available;
    -webkit-text-size-adjust: 100%;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: 'kern' 1;
    font-feature-settings: 'kern' 1;
    /* -webkit-font-smoothing: subpixel-antialiased; */
    /* better font rendering */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: none;
    box-sizing: border-box;
    color: ${colors.black};
    font-family: 'Jost', -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji,
      Segoe UI Symbol;
    font-style: normal;
    overscroll-behavior-y: none;
    /*  */
    /* touch-action: none; */
    -webkit-overflow-scrolling: none;
    /* overflow: hidden; */
    /* Other browsers */
    overscroll-behavior: none;
    /*  */
    font-style: normal;
    font-weight: ${fontWeight.regular};
    font-size: var(--fontSize-paragraph);
    letter-spacing: 0.1px;
    /* line-height: 1.4em; */
    /* width: 100vw; */
    width: var(--document-width);
  }

  b {
    font-weight: ${fontWeight.bold};
  }

  body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;

    &.grid::after {
      content: '';
      display: inline-block;
      position: fixed;
      top: 0;
      left: 0%;
      height: 100vh;
      /* width: 100%; */
      width: var(--site-width);
      margin: 0 var(--padding);
      pointer-events: none;
      --w: calc((100% + var(--gutter)) / ${tokens.desktopCols});
      background: repeating-linear-gradient(
        90deg,
        #f00,
        #f00 calc(var(--w) - var(--gutter)),
        transparent calc(var(--w) - var(--gutter)),
        transparent var(--w)
      );
      opacity: 0.15;
      z-index: 100;
    }
  }

  [tabindex],
  a,
  button,
  input,
  label,
  select,
  textarea {
    -ms-touch-action: manipulation;
    touch-action: manipulation;
  }

  a {
    position: relative;
    color: currentColor;
    outline: none;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    line-height: 1;

    span {
      position: relative;
      display: inline-flex;
      width: auto;
    }
  }

  a * {
    pointer-events: none;
  }

  svg {
    /* fill: currentColor; */
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-size: inherit;
    margin: 0;
  }

  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  dl {
    margin-top: 0;
    margin-bottom: 0;
  }

  dd {
    margin-left: 0;
  }

  img {
    display: inline-flex;
    max-width: 100%;
    height: auto;
  }

  blockquote,
  figure {
    margin: 0;
  }

  cite {
    font-style: normal;
  }

  button,
  input,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: 1.15;
    margin: 0;
  }

  button {
    background-color: transparent;
    border: none;
    color: currentColor;
    cursor: pointer;
    padding: 0;
    outline: none;
    user-select: none;
  }

  button[disabled] {
    cursor: default;
  }

  a *,
  button * {
    pointer-events: none;
  }

  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
    appearance: none;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
  }

  legend {
    margin: 0;
    padding: 0;
  }

  label {
    cursor: pointer;
  }

  .react-tablet-popover-container {
    z-index: 4;
  }

  #modalRoot{
    position: relative;
    z-index: 1222;
  } 
`;

